// extracted by mini-css-extract-plugin
export default {"loginWrapper":"LoginForm_loginWrapper__XTk5S","submitButton":"LoginForm_submitButton__-Yb3R","forgotCredentialWrapper":"LoginForm_forgotCredentialWrapper__rLpz8"};